import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Link } from 'gatsby'
import ReactTooltip from 'react-tooltip'
import * as styles from './styles'
import variables from '../../styles/variables'

const propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired
}

export default function PricingTable({ columns, rows }) {
  const headerIcons = [
    null,
    <styles.SandboxIcon />,
    <styles.DevIcon />,
    <styles.ProdIcon />
  ]

  return (
    <styles.Table>
      <styles.TableBody>
        <styles.AspectRow>
          {_.map(columns, (col, i) => (
            <styles.TableCell key={i}>
              <styles.HeaderCellWrapper>
                <div>
                  {headerIcons[i]}
                </div>
                <div>
                  <styles.ColHeader>
                    {col.header}
                  </styles.ColHeader>
                  <styles.ColSmallHeader>{col.text}</styles.ColSmallHeader>
                </div>
              </styles.HeaderCellWrapper>
            </styles.TableCell>
          ))}
        </styles.AspectRow>

        {_.map(rows, (row, id) => (
          <styles.AspectRow key={'row'.concat(id.toString())}>
            <styles.TableCell>
              <styles.RowHeader>{row.header}</styles.RowHeader>
              {row.smallHeader && <styles.RowSmallHeader>{row.smallHeader}</styles.RowSmallHeader>}
            </styles.TableCell>
            {_.map(row.values, (value, i) => {
              const color = (id === 0 && i === 0) ? variables.colors.jade.dark : null
              const textSize = id === 0 ? '1.3rem' : null
              let cellText
              if (value.text === 'yes') {
                cellText = <styles.CheckIcon data-tip data-for={value.id} />
              } else if (value.text === 'no') {
                cellText = <styles.NoIcon data-tip data-for={value.id} />
              } else {
                cellText = (
                  <styles.CellText
                    bold={id === 0}
                    color={color}
                    textSize={textSize}
                    data-tip
                    data-for={value.id}
                  >
                    {value.text}
                  </styles.CellText>
                )
              }
              const pricingValueCell = (
                <styles.TableCell key={i}>
                  {cellText}
                  {value.smallText && (
                    <styles.CellSmallText>
                      {value.smallText}
                    </styles.CellSmallText>
                  )}
                  {value.explain && (
                    <React.Fragment>
                      <ReactTooltip id={value.id} type="dark" effect="solid" clickable backgroundColor="rgba(0, 0, 0, 0.9)">
                        <span>{value.explain}</span>
                      </ReactTooltip>
                    </React.Fragment>
                  )}
                </styles.TableCell>
              )

              const buttonCell = value.type === 'button' && (
                <styles.TableCell key={i}>
                  <Link to={value.url}>
                    <styles.StyledButton size="small">
                      {value.text}
                    </styles.StyledButton>
                  </Link>
                </styles.TableCell>
              )

              return (
                value.type === 'button' ? buttonCell : pricingValueCell
              )
            })}
          </styles.AspectRow>
        ))}
      </styles.TableBody>
    </styles.Table>
  )
}

PricingTable.propTypes = propTypes
